import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';
import { HomeComponent } from './home.component';
import { Screen1Module } from '@app/listing/screen1.module';
import { Screen2Component } from '@app/home/components/screen2/screen2.component';
import { DashboardModule } from '@app/dashboard/dashboard.module';
import { SharedModule } from '@app/shared/shared.module';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes), DashboardModule, SharedModule],
  exports: [RouterModule],
  declarations: [Screen2Component],
  providers: []
})
export class HomeRoutingModule {}
